import { Col, Container, Row } from "react-bootstrap";
import { useState, useEffect, useRef } from "react";
import dots from "../../assets/images/dots.png";

const Counter = ({counterValues}) => {
  const [animatedValues, setAnimatedValues] = useState({});
  const [hasStarted, setHasStarted] = useState(false);
  const counterRef = useRef(null);

  useEffect(() => {
    // Initialize all values to 0
    const initialValues = {};
    counterValues.forEach(counter => {
      initialValues[counter.id] = 0;
    });
    setAnimatedValues(initialValues);

    // Intersection Observer to detect when section is scrolled into view
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasStarted) {
          setHasStarted(true);
        }
      },
      {
        threshold: 0.3
      }
    );

    if (counterRef.current) {
      observer.observe(counterRef.current);
    }

    return () => {
      if (counterRef.current) {
        observer.unobserve(counterRef.current);
      }
    };
  }, [counterValues, hasStarted]);

  // Animation logic - runs only when hasStarted is true
  useEffect(() => {
    if (!hasStarted) return;

    const intervals = counterValues.map(counter => {
      const targetValue = parseInt(counter.value);
      const increment = Math.ceil(targetValue / 50); // Animate over ~50 steps
      const intervalTime = 30; // milliseconds

      return setInterval(() => {
        setAnimatedValues(prev => ({
          ...prev,
          [counter.id]: Math.min(prev[counter.id] + increment, targetValue)
        }));
      }, intervalTime);
    });

    // Cleanup intervals
    return () => {
      intervals.forEach(interval => clearInterval(interval));
    };
  }, [hasStarted, counterValues]);

  return (
    <Container>
    <div className="counter-design d-md-flex align-items-center justify-content-between mt-4" ref={counterRef}>
      <img src={dots} alt="dots" className="dots-top" />
       <img src={dots} alt="dots" className="dots-bottom" />

      <div className="w-100">
        <Row className="counter-design-mob">
          {counterValues.map((counter => (
              <Col lg={3} md={6} xs={6} key={counter.id}>
                <h2 className="counter-value">{animatedValues[counter.id] || 0}<span>+</span></h2>
                <p className="counter-title">{counter.title}</p>
              </Col>
          )))}
        </Row>
      </div>
  
    </div>
  </Container>
  )
}

export default Counter;